import { render, staticRenderFns } from "./Func53PendenciaPermissoes.vue?vue&type=template&id=34e7fa02"
import script from "./Func53PendenciaPermissoes.vue?vue&type=script&lang=js"
export * from "./Func53PendenciaPermissoes.vue?vue&type=script&lang=js"
import style0 from "./Func53PendenciaPermissoes.vue?vue&type=style&index=0&id=34e7fa02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports